// src/services/cacheConfig.js

/**
 * Cache TTL Configuration for TimeMate Admin
 * Organized by data volatility for optimal performance and cost
 */

// Cache TTL configurations (in milliseconds)
export const CACHE_TTL = {
  // Static data (rarely changes) - cache for 1 hour or more
  COMPANIES: 60 * 60 * 1000,              // 1 hour
  FEATURE_FLAGS: 60 * 60 * 1000,          // 1 hour
  ABSENCE_CATEGORIES: 24 * 60 * 60 * 1000, // 24 hours
  GLOBAL_HOLIDAYS: 24 * 60 * 60 * 1000,    // 24 hours

  // Semi-static data (changes occasionally) - cache 15-30 min
  USER_PROFILES: 30 * 60 * 1000,          // 30 minutes
  VEHICLES: 30 * 60 * 1000,               // 30 minutes
  VEHICLE_CHECKS: 15 * 60 * 1000,         // 15 minutes

  // Dynamic data (changes frequently) - cache 5 min
  ABSENCES_LIST: 5 * 60 * 1000,           // 5 minutes
  TODOS_LIST: 5 * 60 * 1000,              // 5 minutes
  EXPENSES_LIST: 5 * 60 * 1000,           // 5 minutes
  DELIVERY_RECEIPTS: 5 * 60 * 1000,       // 5 minutes
  RECEIPTS: 5 * 60 * 1000,                // 5 minutes (processed receipts)
  RECEIPTS_MONTHS: 30 * 60 * 1000,        // 30 minutes (available months list)

  // Real-time data (use realtime listeners OR very short cache)
  USER_STATUS: 0,                          // No cache, realtime only
  TIME_TRACKING_TODAY: 60 * 1000,         // 1 minute
  PENDING_APPROVALS: 60 * 1000,           // 1 minute

  // Default
  DEFAULT: 5 * 60 * 1000                  // 5 minutes
};

// Cache size limits
export const CACHE_LIMITS = {
  MAX_MEMORY_SIZE: 50 * 1024 * 1024,      // 50MB
  MAX_INDEXEDDB_SIZE: 100 * 1024 * 1024,  // 100MB
};

// Background refresh at 80% of TTL (refresh before expiry)
export const BACKGROUND_REFRESH_THRESHOLD = 0.8;

/**
 * Get TTL for a specific data type
 * @param {string} dataType - The type of data (key from CACHE_TTL)
 * @returns {number} TTL in milliseconds
 */
export function getTTL(dataType) {
  return CACHE_TTL[dataType] || CACHE_TTL.DEFAULT;
}

/**
 * Calculate when background refresh should trigger
 * @param {number} ttl - TTL in milliseconds
 * @returns {number} Time in milliseconds when refresh should start
 */
export function getBackgroundRefreshTime(ttl) {
  return ttl * BACKGROUND_REFRESH_THRESHOLD;
}

export default CACHE_TTL;
